import { defineStore } from 'pinia';
import { useSdk } from '~/sdk';
import { useI18n } from 'vue-i18n';

export const useAnnouncementStore = defineStore('announcement', () => {
  const { locale } = useI18n();

  const state = useAsyncData(async () => {
    return await useSdk().cms.getContent({
      entry: null,
      globalSet: {
        handle: 'announcement',
        fragment: `
          ... on announcement_GlobalSet {
            announcements {
              title
              ... on announcement_Entry {
                callToAction {
                  title
                  target
                  url
                  element {
                    id
                    slug
                    siteId
                  }
                }
              }
            }
            announcement
          }
        `,
      },
    });
  });

  watch(locale, () => state.refresh());

  const { data, pending, error, refresh } = state;

  return { data, pending, error, refresh };
});
